import axios from 'axios'

const baseLoadUrl = 'https://railhub-service-dev.on-trac.co.uk/api/railhub/secured'

export default class RailAppService {

  static getAvailableApps(config) {
    return new Promise((resolve, reject) => {
      axios.get(`${baseLoadUrl}/apps`,config).then((response) => {
        resolve(response)
      }).catch(error => reject(error))
    })
  }

  static getApp(appId) {
    return new Promise((resolve, reject) => {
      axios.get(`${baseLoadUrl}/app/${appId}/true`).then((response) => {
        resolve(response)
      }).catch(error => reject(error))
    })
  }

  static createApp(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${baseLoadUrl}/app`, data).then((response) => {
        resolve(response)
      }).catch(error => reject(error))
    })
  }

  static patchApp(data, appId) {
    return new Promise((resolve, reject) => {
      axios.patch(`${baseLoadUrl}/app/${appId}`, data).then((response) => {
        resolve(response)
      }).catch(error => reject(error))
    })
  }

}
